{
    "general": {
        "about": "About",
        "tos": "Terms of Service",
        "privacy": "Privacy Policy",
        "image_by": "Image by",
        "loading": "Loading…",
        "on": "On",
        "off": "Off",
        "disabled": "Disabled",
        "unavailable": "Unavailable",
        "learn_more": "Learn more"
    },
    "actions": { "submit": "Submit" },
    "login": {
        "title": "Login",
        "welcome": "Welcome!",
        "subtitle": "Sign into Revolt",
        "welcome2": "Hello!",
        "subtitle2": "Create an account",
        "register": "Register",
        "username": "Username",
        "email": "Email",
        "password": "Password",
        "new_password": "New Password",
        "totp": "Authenticator App",
        "recovery": "Recovery Code",
        "invite": "Invite Code",
        "current_password": "Current Password",
        "log_out_other": "Log out of all other sessions",
        "enter": {
            "username": "Enter your preferred username.",
            "email": "Please enter your email.",
            "password": "Enter your password.",
            "new_password": "Enter a new password.",
            "invite": "Enter your invite code.",
            "current_password": "Enter your current password."
        },
        "forgot": "Forgot your password?",
        "reset": "Reset password",
        "set_password": "Set new password",
        "remembered": "Go back to login",
        "new": "New to Revolt?",
        "existing": "Already have an account?",
        "create": "Create a new account",
        "missing_verification": "Didn't receive an email?",
        "resend": "Resend verification",
        "cancel": "Cancel request",
        "check_mail": "Check your mail!",
        "email_delay": "We've sent you a verification email. Please allow up to 10 minutes for it to arrive.",
        "check_spam": "Please check your spam folder if you can't find it",
        "open_mail_provider": "Open {{provider}}",
        "successful_registration": "Successfully registered!",
        "verifying_account": "Verifying your account…",
        "verified_account": "Your account has been verified!",
        "verified_continue": "Continue to login",
        "error": {
            "create": "Failed to register!",
            "login": "Failed to login!",
            "reset": "Failed to reset!",
            "resend": "Failed to resend!",
            "verify": "Failed to verify!"
        },
        "unofficial_instance": "Third-party instance."
    },
    "app": {
        "status": {
            "online": "Online",
            "idle": "Idle",
            "focus": "Focus",
            "busy": "Do Not Disturb",
            "invisible": "Invisible",
            "offline": "Offline",
            "reconnect": "Reconnect"
        },
        "navigation": {
            "tabs": {
                "home": "Home",
                "dev": "Developer",
                "friends": "Friends",
                "contacts": "Contacts",
                "unreads": "Unreads",
                "saved": "Saved notes"
            }
        },
        "home": {
            "directs": "Direct Messages",
            "join-testers": "Join the testers server",
            "join-testers_desc": "You can report issues and discuss improvements with us directly here.",
            "goto-testers": "Go to the testers server",
            "goto-testers_desc": "You can report issues and discuss improvements with us directly here.",
            "donate": "Donate to Revolt",
            "donate_desc": "Support the project by donating - thank you!",
            "feedback": "Give feedback on Revolt",
            "feedback_desc": "Let us know how we can improve our app by giving us feedback.",
            "settings": "Open settings",
            "settings-tooltip": "You can also right-click the user icon in the top left, or left click it if you're already home.",
            "discover": "Discover Revolt",
            "discover_desc": "Find a community based on your hobbies or interests.",
            "group": "Create a group",
            "group_desc": "Invite all of your friends, some cool bots, and throw a big party."
        },
        "main": {
            "categories": {
                "conversations": "Conversations",
                "participants": "Participants",
                "channels": "Channels",
                "members": "Members"
            },
            "channel": {
                "message_where": "Message {{channel_name}}",
                "message_who": "Message @{{person}}",
                "message_saved": "Save to your notes",
                "uploading_file": "Uploading…",
                "failed_upload": "Failed to upload!",
                "attached_file": "Attached {{filename}}",
                "reactions": {
                    "others_reacted": "{{userlist}} and {{count}} others reacted",
                    "unknown_reacted": "{{count}} people reacted",
                    "single_reacted": "1 person reacted",
                    "people_reacted": "{{people}} reacted"
                },
                "reply": {
                    "replying": "Replying to",
                    "toggle": "Toggle author ping"
                },
                "typing": {
                    "single": "{{user}} is typing…",
                    "multiple": "{{userlist}} and {{user}} are typing…",
                    "several": "Several people are typing…"
                },
                "system": {
                    "user_joined": "{{user}} joined",
                    "user_left": "{{user}} left",
                    "user_kicked": "{{user}} was kicked",
                    "user_banned": "{{user}} was banned",
                    "added_by": "{{user}} was added by {{other_user}}",
                    "removed_by": "{{user}} was removed by {{other_user}}",
                    "channel_renamed": "{{user}} renamed the channel to {{name}}",
                    "channel_description_changed": "{{user}} changed the channel description",
                    "channel_icon_changed": "{{user}} changed the channel icon",
                    "channel_ownership_changed": "{{from}} gave {{to}} group ownership",
                    "registered_at": "Registered {{time}}",
                    "message_pinned": "Message {{message}} pinned by {{user}}",
                    "message_unpinned": "Message {{message}} un pinned by {{user}}"
                },
                "start": {
                    "group": "This is the start of your conversation.",
                    "saved": "This is the start of your notes."
                },
                "voice": {
                    "connected": "Voice connected",
                    "leave": "Leave",
                    "mute": "Mute",
                    "unmute": "Unmute"
                },
                "misc": {
                    "viewing_old": "Viewing older messages",
                    "jump_present": "Jump to present",
                    "jump_beginning": "Jump to the beginning",
                    "new_messages": "New messages since {{time_ago}}",
                    "spoiler_attachment": "Spoiler",
                    "failed_load": "Couldn't load message.",
                    "forward_unknown_author": "Unknown",
                    "forward_in": "in",
                    "not_loaded": "Message not loaded, click to jump",
                    "no_sending": "You don't have permission to send messages in this channel.",
                    "timed_out": "You are timed out for {{time}}.",
                    "blocked_messages": "{{count}} blocked messages",
                    "blocked_user": "Blocked User",
                    "sent_file": "Sent an attachment",
                    "sent_multiple_files": "Sent multiple attachments",
                    "load_file": "Load file",
                    "truncated": "File truncated (preview)",
                    "no_pinned_messages": "No messages been pinned yet"
                },
                "edit": {
                    "cancel": "Cancel",
                    "save": "Save"
                },
                "nsfw": {
                    "channel": {
                        "marked": "This channel is marked as NSFW.",
                        "confirm": "Enter Channel"
                    },
                    "confirm": "I confirm that I am at least 18 years old."
                },
                "unknown_user": "<Unknown User>",
                "edited": "(edited)",
                "bot": "Bot",
                "bridge": "bridge",
                "bridged": "Message was sent on another platform",
                "new_to_revolt": "New to Revolt",
                "new_to_server": "New to this server",
                "team": "Official Communication",
                "user_timed_out": "User is timed out for {{time}}.",
                "notifications": {
                    "default": "Use Default",
                    "all": "All Messages",
                    "mention": "Mentions Only",
                    "none": "None",
                    "muted": "Muted"
                },
                "search": {
                    "title": "Search",
                    "back": "« BACK TO MEMBERS",
                    "sort": {
                        "relevance": "Relevance",
                        "latest": "Latest",
                        "oldest": "Oldest"
                    }
                },
                "errors": {
                    "title": "Oops, there's nothing here!",
                    "nochannels": "This server has no channels, or you don't have access to any.",
                    "nochannel": "No channel"
                }
            },
            "groups": {
                "create": "Create a group",
                "name": "Group Name",
                "description": "Group Description",
                "owner": "Group Owner"
            },
            "servers": {
                "create": "Create a server",
                "name": "Server Name",
                "description": "Server Description",
                "channel_name": "Channel Name",
                "channel_type": "Channel Type",
                "category_name": "Category Name",
                "channel_description": "Channel Description",
                "custom_banner": "Custom Banner",
                "owner": "Server Owner",
                "text_channel": "Text Channel",
                "voice_channel": "Voice Channel",
                "use_template": "Use Template",
                "template": "Template"
            }
        },
        "settings": {
            "title": "Settings",
            "categories": {
                "user_settings": "User Settings",
                "client_settings": "Client Settings",
                "danger_zone": "Danger Zone"
            },
            "actions": {
                "remove": "Remove",
                "upload": "Upload",
                "max_filesize": "(max {{filesize}})",
                "edit": "Edit {{name}}"
            },
            "pages": {
                "account": {
                    "title": "My Account",
                    "change_field": "Change",
                    "unique_id": "This is a unique user identifier for your account.",
                    "2fa": {
                        "title": "Two-factor Authentication",
                        "description": "Add an extra layer of security by enabling 2FA on your account.",
                        "view_recovery": "View Recovery Codes",
                        "view_recovery_long": "View and download your 2FA recovery codes.",
                        "generate_recovery": "Generate Recovery Codes",
                        "generate_recovery_long": "Get ready to use 2FA by setting up a recovery method.",
                        "add_auth": "Add Authenticator",
                        "remove_auth": "Remove Authenticator",
                        "two_factor_on": "Two-factor authentication is currently on.",
                        "two_factor_off": "You have not enabled two-factor authentication!"
                    },
                    "manage": {
                        "title": "Account Management",
                        "description": "Disable or delete your account at any time. Both actions will log you out of your active sessions.",
                        "disable": "Disable Account",
                        "disable_description": "You won't be able to access your account unless you contact support - however, your data will not be deleted.",
                        "delete": "Mark Account for Deletion",
                        "delete_still_own_servers": "Cannot delete account until servers are deleted or transferred",
                        "delete_description": "Your account and all of your data (including your messages and friends list) will be queued for deletion. A confirmation email will be sent - you can cancel this within 7 days by contacting support."
                    }
                },
                "profile": {
                    "title": "Profile",
                    "info": "Information",
                    "fetching": "Fetching your profile…",
                    "placeholder": "Write something about yourself…",
                    "profile_picture": "Profile Picture",
                    "custom_background": "Custom Background",
                    "edit_background": "Edit Background",
                    "edit_profile": "Edit Profile"
                },
                "sessions": {
                    "title": "Sessions",
                    "active_sessions": "Active Sessions",
                    "this_device": "This Device",
                    "created": "Created {{time_ago}}",
                    "logout": "Log out of all other sessions"
                },
                "audio": {
                    "title": "Voice Settings",
                    "input_device": "Microphone",
                    "output_device": "Speaker / Headset",
                    "tip_retry": "You didn't give Revolt permission to access your microphone. Please {{retryBtn}}.",
                    "tip_grant_permission": "You need to grant permission to access audio settings.",
                    "device_label_NA": "N/A",
                    "button_retry": "retry",
                    "button_grant": "Grant permission"
                },
                "appearance": {
                    "title": "Appearance",
                    "theme": "Theme",
                    "colours": { "title": "Colours" },
                    "emoji": { "title": "Emoji" },
                    "fonts": { "title": "Fonts" },
                    "advanced_options": { "title": "Advanced Options" },
                    "display": {
                        "default": "Default",
                        "compact": "Compact",
                        "default_description": "Beautiful, sleek and modern.",
                        "compact_description": "Good old IRC."
                    },
                    "discover": {
                        "title": "Discover Themes",
                        "description": "Browse themes made by the community"
                    },
                    "color": { "light": "light", "dark": "dark" },
                    "accent_selector": "Accent Colour",
                    "appearance_options": {
                        "title": "Appearance Options",
                        "show_send": "Always show Send Message button",
                        "show_send_desc": "If this is disabled, the Send Message button will only appear on mobile.",
                        "show_account_age": "Always show account age next to join messages",
                        "show_account_age_desc": "If this is disabled, the account age will only be shown for new users."
                    },
                    "theme_options": {
                        "title": "Theme Options",
                        "follow": "Follow system theme",
                        "follow_desc": "If this is enabled, you won't be able to change your theme or use a custom theme.",
                        "seasonal": "Seasonal Theme",
                        "seasonal_desc": "Displays effects in the home tab during holiday seasons.",
                        "transparency": "Transparency Effects",
                        "transparency_desc": "Enables transparency effects throughout the app."
                    },
                    "emoji_pack": "Emoji Pack",
                    "message_display": "Message Display",
                    "advanced": "Advanced Options",
                    "overrides": "Theme Overrides",
                    "reset_overrides": "Reset overrides",
                    "import": "Import a theme",
                    "import_theme": "Import theme from string",
                    "theme_data": "Theme Data",
                    "custom_css": "Custom CSS",
                    "sync": "Sync Options",
                    "font": "Font",
                    "mono_font": "Monospace Font Selector",
                    "ligatures": "Font Ligatures",
                    "ligatures_desc": "For supported fonts, ligatures combine characters together - for example, turning -> into an arrow."
                },
                "accessibility": {
                    "title": "Accessibility",
                    "reduced_motion": "Reduced Motion",
                    "descriptions": {
                        "reduced_motion": "If this is enabled, animations and motion effects won't play or will be less intense."
                    }
                },
                "notifications": {
                    "title": "Notifications",
                    "push_notifications": "Push Notifications",
                    "enable_desktop": "Enable Desktop Notifications",
                    "enable_push": "Enable Push Notifications",
                    "sounds": "Sounds",
                    "descriptions": {
                        "enable_desktop": "If this is enabled, you will receive notifications while the app is open.",
                        "enable_push": "If this is enabled, you will receive notifications when you're offline."
                    },
                    "sound": {
                        "message": "Message Received",
                        "outbound": "Message Sent",
                        "call_join": "User Joined Call",
                        "call_leave": "User Left Call"
                    }
                },
                "language": {
                    "title": "Language",
                    "select": "Select your language",
                    "const": "Constructed languages",
                    "other": "Other language options"
                },
                "sync": {
                    "title": "Sync",
                    "options": "Sync Options",
                    "categories": "Sync Categories",
                    "descriptions": {
                        "appearance": "This will sync appearance options, such as your chosen emoji pack and message density.",
                        "theme": "This will sync your chosen theme, colours and any custom CSS.",
                        "locale": "This will sync your currently chosen language."
                    }
                },
                "native": { "title": "Desktop Settings" },
                "experiments": {
                    "title": "Experiments",
                    "features": "Available Features",
                    "not_available": "No experiments are available at this time."
                },
                "plugins": {
                    "title": "Plugins",
                    "wip": "Warning: this feature is still in development.",
                    "delete_plugin": "Delete",
                    "no_plugins": "No plugins are currently installed."
                },
                "donate": { "title": "Donate" },
                "source_code": "Source Code",
                "bots": {
                    "title": "My Bots",
                    "create_bot": "Create a Bot",
                    "copy_invite": "Copy Invite Link",
                    "add": "Add Bot",
                    "unique_id": "This is a unique identifier for your bot. This is not the bot's token.",
                    "token": "Token",
                    "public_bot_tip": "This bot is public. Anyone can invite it.",
                    "private_bot_tip": "This bot is private. Only you can invite it.",
                    "public_bot": "Public Bot",
                    "profile": "Bot profile",
                    "public_bot_desc": "If this is enabled, other users can add this bot to servers and group messages.",
                    "interactions_url": "Interactions URL",
                    "reserved": "Note: this field is reserved for the future."
                },
                "theme_shop": {
                    "title": "Theme Shop",
                    "description": "Browse hundreds of themes, created and curated by the community.",
                    "search": "Search themes…",
                    "category": {
                        "saved": "Saved",
                        "manage": "Manage saved",
                        "new": "New this week",
                        "default": "Default themes",
                        "highest": "Highest rated",
                        "viewall": "View all"
                    },
                    "active": "Currently active",
                    "use": "Use theme",
                    "by": "by"
                },
                "keybinds": {
                    "title": "Keybinds",
                    "description": "View and set keybinds",
                    "search": "Search keybinds…",
                    "add_keybind": "Add new keybind",
                    "edit_keybind": "Edit keybind",
                    "remove_keybind": "Remove keybind",
                    "reset_keybind": "Reset keybind to {{keybind}}",
                    "category": {
                        "navigation": "Navigation",
                        "messaging": "Messaging",
                        "advanced": "Advanced"
                    },
                    "action": {
                        "navigate_channel_up": {
                            "title": "Navigate to the previous channel",
                            "description": "Navigate to the previous channel."
                        },
                        "navigate_channel_down": {
                            "title": "Navigate to the next channel",
                            "description": "Navigate to the next channel."
                        },
                        "navigate_server_up": {
                            "title": "Navigate to the previous server",
                            "description": "Navigate to the previous server."
                        },
                        "navigate_server_down": {
                            "title": "Navigate to the next server",
                            "description": "Navigate to the next server."
                        },
                        "messaging_edit_previous_message": {
                            "title": "Edit previous message",
                            "description": "Edit the previously sent message in the currently loaded messaging view."
                        },
                        "auto_complete_up": {
                            "title": "Previous Autocomplete Selection",
                            "description": "Move the autocomplete selection to the previous one."
                        },
                        "auto_complete_down": {
                            "title": "Next Autocomplete Selection",
                            "description": "Move the autocomplete selection to the next one."
                        },
                        "auto_complete_select": {
                            "title": "Confirm Autocomplete Selection",
                            "description": "Confirm the current autocompletion selection."
                        },
                        "input_submit": {
                            "title": "Submit Input",
                            "description": "An advanced keybind that is typically used to submit the current input.\nThis may include submitting a message, submitting an edit to a message, submitting a search, etc.."
                        },
                        "input_cancel": {
                            "title": "Cancel Input",
                            "description": "An advanced keybind that is typically used to cancel the current input.\nThis may include cancelling a message edit, removing a queued image, or similar scenarios."
                        },
                        "input_force_submit": {
                            "title": "Force Submit Input",
                            "description": "An advanced keybind that is typically used to forcefully submit the current input, ignoring some checks or other keybinds.\nThis may include submitting a message instead of confirming the autocomplete selection."
                        },
                        "messaging_scroll_to_bottom": {
                            "title": "Scroll to bottom of messages",
                            "description": "Scrolls to the bottom of the messaging view."
                        },
                        "messaging_mark_channel_read": {
                            "title": "Mark channel as read",
                            "description": "Marks the current channel as read."
                        },
                        "navigate_previous_context": {
                            "title": "Navigate to the previous context",
                            "description": "An advanced keybind that is typically used to close the setting page, a modal, or a popup and return back to the previous context."
                        },
                        "developer_toggle_all_experiments": {
                            "title": "Toggle experiment safe mode",
                            "description": "This will enable / disable all experiments at once."
                        }
                    }
                },
                "feedback": {
                    "title": "Feedback",
                    "description": "Submit feedback",
                    "suggest": "Submit feature suggestion",
                    "suggest_desc": "Suggest new Revolt features on GitHub discussions.",
                    "issue": "Create a new issue",
                    "issue_desc": "To help us more easily triage issues, you can create an issue on GitHub.",
                    "bug": "Bug Tracker",
                    "bug_desc": "View currently active bug reports here.",
                    "contact_support": "Contact Support"
                },
                "logOut": "Log Out"
            },
            "channel_pages": {
                "overview": {
                    "title": "Overview",
                    "name": "Channel Name",
                    "description": "Channel Description"
                },
                "permissions": { "title": "Permissions" },
                "webhooks": { "title": "Webhooks" }
            },
            "server_pages": {
                "overview": {
                    "title": "Overview",
                    "name": "Server Name",
                    "description": "Channel Description",
                    "system_messages": "System Message Channels"
                },
                "management": { "title": "User Management" },
                "customisation": { "title": "Customisation" },
                "members": { "title": "Members", "add": "Add member" },
                "invites": {
                    "title": "Invites",
                    "code": "Invite Code",
                    "invitor": "Inviter",
                    "channel": "Channel",
                    "revoke": "Revoke"
                },
                "bans": {
                    "title": "Bans",
                    "user": "User",
                    "reason": "Ban Reason",
                    "revoke": "Revoke",
                    "no_reason": "No ban reason."
                },
                "roles": { "title": "Roles" },
                "categories": { "title": "Categories" },
                "emojis": { "title": "Emojis", "upload": "Upload Emoji" }
            },
            "tips": {
                "account": {
                    "a": "Want to customise your public profile?",
                    "b": "Head over to your profile settings."
                },
                "languages": {
                    "a": "Are we missing a language you want?",
                    "b": "Help us out by contributing more translations."
                },
                "sessions": {
                    "a": "If you see an unknown session on the list,",
                    "b": "secure your account by changing your password and setting up 2FA."
                }
            },
            "permissions": {
                "default_role": "Default",
                "server": "Server Permissions",
                "channel": "Channel Permissions",
                "create_role": "Create a new role",
                "role_name": "Role Name",
                "role_colour": "Role Colour",
                "role_options": "Role Options",
                "role_ranking": "Role Ranking",
                "delete_role": "Delete Role",
                "hoist_role": "Hoist Role",
                "hoist_desc": "Display this role above others.",
                "title": "Permissions for {{role}}",
                "edit_title": "Edit Permissions"
            }
        },
        "special": {
            "contacts": { "list": "Contacts" },
            "copy_username": "Click to copy username",
            "copy": "Click to copy",
            "friends": {
                "pending": "Pending requests",
                "sent": "Outgoing",
                "blocked": "Blocked",
                "incoming": "Incoming friend request.",
                "outgoing": "Outgoing friend request.",
                "nobody": "Nobody here yet!",
                "from": {
                    "single": "From {{user}}",
                    "multiple": "From {{userlist}} and {{user}}",
                    "several": "From {{userlist}} and {{count}} more…"
                }
            },
            "status": {
                "offline": "Offline.",
                "disconnected": "Disconnected.",
                "connecting": "Connecting…",
                "reconnecting": "Reconnecting…"
            },
            "server-badges": {
                "official": "Official Server",
                "verified": "Verified Server"
            },
            "modals": {
                "error": "An error occurred!",
                "clipboard": {
                    "unavailable": "Clipboard is unavailable!",
                    "https": "You are currently not in a HTTPS context.",
                    "copy": "Manual Copy:"
                },
                "confirm": "Confirm action",
                "signed_out": "You were signed out!",
                "token_reveal": "{{name}}'s Token",
                "onboarding": {
                    "welcome": "Welcome to",
                    "pick": "Pick a username that you want people to be able to find you by. This can be changed later in your user settings."
                },
                "prompt": {
                    "confirm_leave": "Leave {{name}}?",
                    "confirm_leave_long": "You won't be able to rejoin unless you are re-invited.",
                    "confirm_close_dm": "Close conversation with {{name}}?",
                    "confirm_close_dm_long": "You can re-open it later, but it will disappear on both sides.",
                    "confirm_delete": "Delete {{name}}?",
                    "confirm_delete_long": "Once it's deleted, there's no going back.",
                    "confirm_delete_message_long": "Are you sure you want to delete this?",
                    "create_invite_generate": "Generating invite…",
                    "create_invite_created": "Here is your new invite code:",
                    "confirm_kick": "Are you sure you want to kick {{name}}?",
                    "confirm_ban": "You are about to ban {{name}}",
                    "confirm_ban_reason": "Ban Reason",
                    "unfriend_user": "Unfriend {{name}}?",
                    "unfriend_user_long": "You may not be able to talk to them again until you add them back.",
                    "block_user": "Block {{name}}?",
                    "block_user_long": "Are you sure you want to block {{name}}? They will also be removed from your friends list.",
                    "silent_leave": "Silently Leave",
                    "members_not_notified": "Other members will not be notified"
                },
                "account": {
                    "change": {
                        "username": "Change your username",
                        "email": "Change your email",
                        "password": "Change your password",
                        "display_name": "Change your display name"
                    },
                    "failed": "Failed to change!"
                },
                "mfa": {
                    "recovery_codes": "Your recovery codes",
                    "save_codes": "Please save these to a safe location.",
                    "confirm": "Please confirm this action using the selected method.",
                    "select_method": "Please select a method to authenticate your request.",
                    "enable_totp": "Enable authenticator app",
                    "prompt_totp": "Please scan or use the token below in your authenticator app.",
                    "enter_code": "Enter Code"
                },
                "changelogs": {
                    "title": "Changelogs",
                    "description": "Read about updates to Revolt.",
                    "older": "View older updates"
                },
                "out_of_date": {
                    "title": "Your client is out of date!",
                    "description": "It must be updated in order to work with recent changes.",
                    "version": "Your client is at {{client}}, but the server requires {{server}}.",
                    "ignore": "Ignore update",
                    "attempting": "Attempting to update…"
                },
                "external_links": {
                    "title": "External links can be dangerous!",
                    "short": "Are you sure you want to go to:",
                    "trust_domain": "Trust this domain"
                },
                "sessions": {
                    "title": "Are you sure you want to clear your sessions?",
                    "short": "You cannot undo this action.",
                    "accept": "Remove all sessions"
                },
                "report": {
                    "message": "Report Message",
                    "by_name": "Report {{name}}",
                    "reason": "Reason",
                    "reported": "Reported",
                    "thank_you": "Thank you for helping to keep Revolt safe. We will review your report as soon as possible.",
                    "block_user": "Would you like to block this user?",
                    "additional_context": "Additional Information",
                    "no_reason": "No reason specified / other reason",
                    "content_reason": {
                        "Illegal": "Content breaks one or more laws",
                        "PromotesHarm": "Content promotes harm to others or self",
                        "SpamAbuse": "This is spam or platform abuse",
                        "Malware": "This is malware",
                        "Harassment": "This is harassment or abuse targeted at another user"
                    },
                    "user_reason": {
                        "SpamAbuse": "User is sending spam or otherwise abusing the platform",
                        "InappropriateProfile": "User's profile is inappropriate for a general audience",
                        "Impersonation": "This user is impersonating someone else",
                        "BanEvasion": "This user is evading a ban",
                        "Underage": "This user is not old enough to have an account"
                    }
                },
                "actions": {
                    "ok": "OK",
                    "ban": "Ban",
                    "done": "Done",
                    "kick": "Kick",
                    "save": "Save",
                    "hide": "Hide",
                    "edit": "Edit",
                    "block": "Block",
                    "close": "Close",
                    "leave": "Leave",
                    "reset": "Reset",
                    "back": "Go back",
                    "remove": "Remove",
                    "delete": "Delete",
                    "report": "Report",
                    "create": "Create",
                    "reveal": "Reveal",
                    "update": "Update",
                    "cancel": "Cancel",
                    "preview": "Preview",
                    "confirm": "Confirm",
                    "reload": "Reload App",
                    "continue": "Continue",
                    "send_email": "Send Email",
                    "dont_block": "Don't block"
                },
                "download_error": {
                    "title": "Download failed",
                    "message": "Download failed: {{error}}"
                },
                "edit_keybind": {
                    "title": "Edit keybind for {{action}}",
                    "placeholder": "Press keys to record"
                }
            },
            "popovers": {
                "user_profile": {
                    "profile": "Profile",
                    "mutual_friends": "Mutual Friends",
                    "mutual_groups": "Mutual Groups",
                    "roles": "Roles",
                    "mutual_servers": "Mutual Servers",
                    "empty": "It's a bit empty in here…",
                    "no_users": "No mutual friends",
                    "no_groups": "No mutual groups",
                    "no_servers": "No mutual servers",
                    "sub": {
                        "badges": "Badges",
                        "information": "Information",
                        "connections": "Connections"
                    },
                    "badges": {
                        "founder": "Founder",
                        "translator": "Translator",
                        "supporter": "Supporter",
                        "moderation": "Platform Moderation",
                        "responsible_disclosure": "Responsibly Disclosed Security Issues",
                        "early_adopter": "Early Adopter"
                    }
                },
                "emoji_picker": {
                    "emoji_category": {
                        "default": "Default",
                        "most_used": "Frequently used",
                        "chosen": "Chosen"
                    }
                },
                "user_picker": { "select": "Select contacts to add." },
                "create_bot": {
                    "title": "Create a new bot",
                    "failed": "Failed to create a bot!"
                },
                "server_identity": {
                    "title": "Change identity on {{server}}",
                    "nickname": "Nickname",
                    "avatar": "Avatar"
                },
                "forward_picker": {
                    "title": "Forward",
                    "subtitle": "Choose where you want to share this message",
                    "search": "Search",
                    "add_message": "Add a message",
                    "send": "Send",
                    "n_messages_1": "{{n}} message",
                    "n_messages_2": "{{n}} messages",
                    "n_messages_5": "{{n}} messages",
                    "n_attachments_1": "{{n}} attachment",
                    "n_attachments_2": "{{n}} attachments",
                    "n_attachments_5": "{{n}} attachments",
                    "direct_messages": "Direct Messages",
                    "servers": "Servers"
                }
            },
            "requires_online": "You need to be online to view this.",
            "invite": {
                "invited_by": "Invited by {{user}}",
                "login": "Login to Revolt",
                "accept": "Accept Invite",
                "user_count": "{{member_count}} users",
                "invalid": "Invalid invite!",
                "invalid_desc": "The invite may not exist, or you don't have permission to join."
            }
        },
        "context_menu": {
            "copy_id": "Copy ID",
            "copy_selection": "Copy selection",
            "copy_text": "Copy text",
            "copy_uid": "Copy user ID",
            "copy_sid": "Copy server ID",
            "copy_cid": "Copy channel ID",
            "copy_mid": "Copy message ID",
            "copy_message_link": "Copy message link",
            "mention": "Mention",
            "message_user": "Message",
            "to_saved_messages": "To saved messages",
            "open_roles_menu": "Roles",
            "view_profile": "View profile",
            "mark_as_read": "Mark as read",
            "mark_unread": "Mark as unread",
            "retry_message": "Retry send",
            "cancel_message": "Cancel send",
            "reply_message": "Reply",
            "forward_message": "Forward",
            "quote_message": "Quote message",
            "quote_selection": "Quote selection",
            "edit_message": "Edit message",
            "report_message": "Report message",
            "delete_message": "Delete message",
            "make_owner": "Give group ownership",
            "remove_member": "Remove from group",
            "kick_member": "Kick member",
            "ban_member": "Ban member",
            "open_file": "Open file",
            "save_as": "Save as...",
            "show_in_folder": "Show in folder",
            "downloading": "Downloading...",
            "go_to_message": "Go to message",
            "save_file": "Save file",
            "open_image": "Open image",
            "save_image": "Save image",
            "copy_image": "Copy image",
            "open_video": "Open video",
            "save_video": "Save video",
            "copy_link": "Copy link",
            "open_link": "Open link",
            "block_user": "Block user",
            "unblock_user": "Unblock user",
            "add_friend": "Add friend",
            "accept_friend": "Accept friend request",
            "remove_friend": "Remove friend",
            "reject_friend": "Reject friend request",
            "cancel_friend": "Cancel friend request",
            "report_user": "Report user",
            "custom_status": "Custom status",
            "clear_status": "Clear status",
            "set_custom_status": "Set a custom status",
            "leave_group": "Leave group",
            "leave_server": "Leave server",
            "close_dm": "Close DM",
            "report_server": "Report server",
            "delete_server": "Delete server",
            "edit_identity": "Edit identity",
            "edit_your_identity": "Edit your identity",
            "delete_channel": "Delete channel",
            "create_channel": "Create channel",
            "create_category": "Create category",
            "create_invite": "Create invite",
            "open_notification_options": "Notification options",
            "open_channel_settings": "Channel settings",
            "open_server_settings": "Server settings",
            "open_group_settings": "Group settings",
            "pin_message": "Pin message",
            "unpin_message": "Un pin message",
            "select_message": "Select"
        },
        "selection": { "cancel": "Cancel", "forward": "Forward" },
        "message_actions": {
            "reply": "Reply",
            "forward": "Forward",
            "react": "React",
            "edit": "Edit",
            "delete": "Delete",
            "more": "More"
        },
        "permissions": { "required": "Permissions required" }
    },
    "quantities": {
        "members": { "one": "1 Member", "many": "{{count}} Members" },
        "attachments": { "one": "1 Attachment", "many": "{{count}} Attachments" },
        "dropFiles": { "one": "Drop a file", "many": "Drop {{count}} files" }
    },
    "dayjs": {
        "lastDay": "[Yesterday at] {{time}}",
        "sameDay": "[Today at] {{time}}",
        "nextDay": "[Tomorrow at] {{time}}",
        "lastWeek": "[Last] dddd [at] {{time}}",
        "nextWeek": "dddd [at] {{time}}",
        "defaults": {
            "date_separator": "/",
            "date_format": "traditional",
            "twelvehour": "no"
        }
    },
    "notifications": {
        "sent_request": "@{{person}} sent you a friend request.",
        "now_friends": "You are now friends with @{{person}}!"
    },
    "error": {
        "NetworkError": "Network error.",
        "Unauthorized": "Unauthorized.",
        "Unlabelled": "Something happened.",
        "FailedValidation": "Failed to validate fields.",
        "DatabaseError": "Database error.",
        "InternalError": "Internal error.",
        "MissingPermission": "Missing permission.",
        "UnknownError": "See console.",
        "OperationFailed": "Operation failed.",
        "RenderFail": "Template rendering failed.",
        "MissingHeaders": "Missing headers.",
        "InvalidSession": "Invalid session.",
        "UnverifiedAccount": "Unverified account.",
        "UnknownUser": "Unknown user.",
        "EmailInUse": "Email in use.",
        "EmailFailed": "Email failed to send.",
        "InvalidCredentials": "Email or password is wrong.",
        "InvalidToken": "Invalid token",
        "MissingInvite": "Missing invite code in request.",
        "InvalidInvite": "Invalid code",
        "AlreadyOnboarded": "Already finished onboarding.",
        "UsernameTaken": "That username is taken.",
        "AlreadyFriends": "Already friends with this user.",
        "AlreadySentRequest": "Already sent a request to this user.",
        "Blocked": "You have blocked this user.",
        "BlockedOther": "This user has blocked you.",
        "NoEffect": "This request had no effect.",
        "RequiredField": "Required",
        "TooShort": "Too short",
        "TooLong": "Too long",
        "InvalidEmail": "Invalid email address",
        "Unavailable": "Unavailable.",
        "FileTooLarge": "File is too large. Maximum file size is {{filesize}}.",
        "FailedToReceive": "Server failed to receive your file.",
        "MissingData": "Request is missing data.",
        "ProbeError": "Failed to get file metadata.",
        "IoError": "Server encountered an I/O error.",
        "UnsupportedBrowser": "Browser is missing support for this feature.",
        "DeniedNotification": "You denied notification access. Check page settings.",
        "CompromisedPassword": "This password is compromised.",
        "ReachedMaximumBots": "You've reached the maximum amount of bots.",
        "AudioPermissionBlock": "No access to your microphone. Please check your browser's configuration.",
        "DiscriminatorChangeRatelimited": "Too many tag changes.",
        "LockedOut": "Too many failed login attempts. Please try again later."
    },
    "shortcuts": { "ctrlc": "Ctrl + C" },
    "permissions": {
        "ManageChannels": {
            "t": "Manage Channels",
            "d": "Allows members to create, edit and delete channels."
        },
        "ManageServer": {
            "t": "Manage Server",
            "d": "Allows members to change this server's name, description, icon and other related information."
        },
        "ManagePermissions": {
            "t": "Manage Permissions",
            "d": "Allows members to change permissions for channels and roles with a lower ranking."
        },
        "ManageRole": {
            "t": "Manage Roles",
            "d": "Allows members to create, edit and delete roles with a lower rank than theirs, and modify role permissions on channels."
        },
        "ManageCustomisation": {
            "t": "Manage Customisation",
            "d": "Allows members to create, edit and delete emojis."
        },
        "KickMembers": {
            "t": "Kick Members",
            "d": "Allows members to remove members from this server. Kicked members may rejoin with an invite."
        },
        "BanMembers": {
            "t": "Ban Members",
            "d": "Allows members to permanently remove members from this server."
        },
        "TimeoutMembers": {
            "t": "Timeout Members",
            "d": "Allows members to temporarily prevent users from interacting with the server."
        },
        "AssignRoles": {
            "t": "Assign Roles",
            "d": "Allows members to assign roles below their own rank to other members."
        },
        "ChangeNickname": {
            "t": "Change Nickname",
            "d": "Allows members to change their nickname on this server."
        },
        "ManageNicknames": {
            "t": "Manage Nicknames",
            "d": "Allows members to change the nicknames of other members."
        },
        "ChangeAvatar": {
            "t": "Change Avatar",
            "d": "Allows members to change their avatar on this server."
        },
        "RemoveAvatars": {
            "t": "Remove Avatars",
            "d": "Allows members to remove the server avatars of other members on this server."
        },
        "ViewChannel": {
            "t": "View Channel",
            "d": "Allows members to view any channels they have this permission on."
        },
        "ReadMessageHistory": {
            "t": "Read Message History",
            "d": "Allows members to read the message history of this channel."
        },
        "SendMessage": {
            "t": "Send Messages",
            "d": "Allows members to send messages in text channels."
        },
        "ManageMessages": {
            "t": "Manage Messages",
            "d": "Allows members to delete messages sent by other members."
        },
        "ManageWebhooks": {
            "t": "Manage Webhooks",
            "d": "Allows members to control webhooks in a channel."
        },
        "ManageChannel": {
            "t": "Manage Channels",
            "d": "Allows members to edit or delete a channel."
        },
        "InviteOthers": {
            "t": "Invite Others",
            "d": "Allows members to invite other users to a channel."
        },
        "SendEmbeds": {
            "t": "Send Embeds",
            "d": "Allows members to send embedded content, whether from links or custom text embeds."
        },
        "UploadFiles": {
            "t": "Upload Files",
            "d": "Allows members to upload files in text channels."
        },
        "Masquerade": {
            "t": "Masquerade",
            "d": "Allows members to change their name and avatar per-message."
        },
        "React": {
            "t": "Use Reactions",
            "d": "Allows members to react to messages."
        },
        "Connect": {
            "t": "Connect",
            "d": "Allows members to connect to a voice channel."
        },
        "Speak": {
            "t": "Speak",
            "d": "Allows members to speak in a voice channel."
        },
        "Video": {
            "t": "Video",
            "d": "Allows members to stream video in a voice channel."
        },
        "MuteMembers": {
            "t": "Mute Members",
            "d": "Allows members to mute others in a voice channel."
        },
        "DeafenMembers": {
            "t": "Deafen Members",
            "d": "Allows members to deafen others in a voice channel."
        },
        "MoveMembers": {
            "t": "Move Members",
            "d": "Allows members to move others between voice channels."
        }
    },
    "keys": {
        "Escape": { "short": "Esc" },
        "Control": { "short": "Ctrl" },
        "Insert": { "short": "Ins" },
        "Delete": { "short": "Del" },
        "Backspace": { "short": "Backspace" },
        "PageUp": { "full": "Page Up", "short": "PgUp" },
        "PageDown": { "full": "Page Down", "short": "PgDown" },
        "PrintScreen": { "full": "Print Screen", "short": "PrtSc" },
        "ScrollLock": { "full": "Scroll Lock", "short": "ScrLK" },
        "CapsLock": { "full": "Caps Lock" }
    }
}
